import actions from './actions';
import { createReducer } from '../../helpers/reducer';

const initState = {
  isLoggingInWithSSO: false,
};

function onLoginWithSSORequest(state) {
  return { ...state, isLoggingInWithSSO: true };
}

function onLoginWithSSOSuccess(state) {
  return { ...state, isLoggingInWithSSO: false };
}

function onLoginWithSSOError(state) {
  return { ...state, isLoggingInWithSSO: false };
}

export default createReducer(initState, {
  [actions.LOGIN_WITH_SSO_REQUEST]: onLoginWithSSORequest,
  [actions.LOGIN_WITH_SSO_SUCCESS]: onLoginWithSSOSuccess,
  [actions.LOGIN_WITH_SSO_ERROR]: onLoginWithSSOError,
});
